import {ElementUtil} from './elementUtil.js';
import {TransformChainHelpDialog} from '../component/common/transformChainHelpDialog.js';

/**
 * Integration/data-handler option names for unit/driver transform chains.
 */
export function isTransformChainOption(optionName) {
	return optionName != null && String(optionName).endsWith('_TRANSFORM_CHAIN');
}

/**
 * Label row with help icon for transform chain fields (Vaadin label slot).
 */
export function attachTransformChainLabel(textField, labelText) {
	textField.label = '';

	var labelRow = ElementUtil.create({
		tag: 'span',
		slot: 'label',
		style: 'display: inline-flex; align-items: center; gap: 6px; width: 100%; box-sizing: border-box;',
		children: [
			{
				tag: 'span',
				text: labelText,
				style: 'flex: 1 1 auto;'
			},
			{
				tag: 'vaadin-icon',
				itemid: 'transform-chain-help-icon',
				icon: 'vaadin:question-circle',
				style: 'cursor: pointer; width: var(--lumo-icon-size-s); height: var(--lumo-icon-size-s); flex-shrink: 0; color: var(--lumo-secondary-text-color);',
				title: 'Transform chain help'
			}
		]
	});

	textField.appendChild(labelRow);

	ElementUtil.query(labelRow, 'transform-chain-help-icon').addEventListener('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		TransformChainHelpDialog.show();
	});
}
